import React, { useEffect, useState } from "react";
import WidgetPreview from "../WidgetPreview/WidgetPreview";
import ColorPicker from "../ColorPicker/ColorPicker";
import Input from "../../ui/Input/Input";
import Select from "../../ui/Select/Select";
import styles from "./WidgetIntegrationForm.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { getAllDialogs } from "../../utils/api/actions/dialogs";
import { getAssistantList } from "../../utils/api/actions/assistant";
import { getWidgetList, getWidgetToken } from "../../utils/api/actions/widget";
import { setNewWidget } from "../../store/slices/widgetSlice";
import ScreenHeader from "../ScreenHeader/ScreenHeader";
import { WidgetIcon } from "../../assets/icons/WidgetIcon";
import SaveIcon from "../../assets/icons/SaveIcon";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { validateWidgetFields } from "../../utils/methods/validationField";

export const WidgetIntegrationForm = ({ data }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const errorFields = (messages) => {
    toast.dismiss("customId");
    messages.forEach((message) =>
      toast.error(message, { toastId: "customId" })
    );
  };
  const isEmptyObject = (obj) => obj && Object.keys(obj).length > 0;

  const { activeAssistant } = useSelector((state) => state?.assistant);
  const { dataAssistants } = useSelector((state) => state?.assistant);
  const { newWidget } = useSelector((state) => state?.widget);
  const user = useSelector((state) => state?.user?.data);
  const assistants = useSelector((state) => state.assistant.dataAssistants);

  const userId = user?.id;

  useEffect(() => {
    if (!newWidget) {
      dispatch(
        setNewWidget({
          userId: userId,
          name: "",
          assistantId: assistants ? assistants[0]?.id : "",
          assistantName: assistants ? assistants[0]?.name : "",
          color: "#2ca1f8",
          header: "Чат с ассистентом",
          allowedDomains: "",
          backgroundColor: "#ffffff",
          textColor: "#ffffff",
        })
      );
    }
  }, [assistants, dispatch, newWidget, userId]);

  const [colorMain, setColorMain] = useState("#2ca1f8");
  const [colorText, setColorText] = useState("#ffffff");
  const [colorBg, setColorBg] = useState("#ffffff");

  useEffect(() => {
    if (userId) {
      dispatch(getAllDialogs(userId));
      dispatch(getAssistantList(userId));
      dispatch(getWidgetList(userId));
    }
  }, [dispatch, userId]);

  const handlerInput = (e) => {
    if (newWidget) {
      let res = JSON.parse(JSON.stringify(newWidget));

      Object.defineProperty(res, e.target.name, {
        value: e.target.value,
      });

      dispatch(setNewWidget(res));
    }
  };

  const selectObserver = (val) => {
    if (newWidget) {
      let res = JSON.parse(JSON.stringify(newWidget));

      Object.defineProperty(res, "assistantId", {
        value: val,
      });

      const selectedAssistant = dataAssistants.find(
        (assistant) => assistant.id === val
      );
      Object.defineProperty(res, "assistantName", {
        value: selectedAssistant ? selectedAssistant.name : "",
      });

      dispatch(setNewWidget(res));
    }
  };

  const handleSave = () => {
    if (isEmptyObject(newWidget)) {
      if (validateWidgetFields(newWidget, errorFields)) {
        dispatch(getWidgetToken(newWidget, navigate));
      }
    }
  };

  const handleCancel = () => {
    dispatch(setNewWidget(null));
    navigate("/integration");
  };

  const actions = [
    {
      title: "Сохранить",
      icon: <SaveIcon />,
      className: styles.addButton,
      titleClassName: styles.titleAddButton,
      onClick: handleSave,
    },
    {
      title: "Отмена",
      className: styles.cancelButton,
      titleClassName: styles.titleCancelButton,
      onClick: handleCancel,
    },
  ];

  return (
    <div className={styles.container}>
      <ScreenHeader
        actions={actions}
        title={
          <>
            Новая интеграция{" "}
            <WidgetIcon width={20} height={20} fill={"#151515"} />
          </>
        }
      />
      <div className={styles.containerForm}>
        <div className={styles.newWidgetContainer}>
          <Select
            containerStyle={styles.containerSelect}
            labelStyle={styles.labelSelect}
            dataSelect={dataAssistants}
            title="Выберите ассистента"
            selectObserver={selectObserver}
            settings={activeAssistant?.settings}
            nameSelectedOption={"Ассистент"}
          />
          <div className={styles.inputContainer}>
            <Input
              className={styles.child}
              label="Введите название виджета"
              labelStyle={styles.labelInput}
              backgroundStyle={styles.labelBackground}
              inputStyle={styles.input}
              name="name"
              value={newWidget ? newWidget.name : ""}
              onChange={handlerInput}
              type={"text"}
            />
          </div>

          <div className={styles.inputContainer}>
            <Input
              className={styles.child}
              label={"Введите заголовок виджета"}
              labelStyle={styles.labelInput}
              backgroundStyle={styles.labelBackground}
              inputStyle={styles.input}
              value={newWidget ? newWidget.header : ""}
              name="header"
              onChange={handlerInput}
              type={"text"}
              placeholder={"Название"}
            />
          </div>
          <div className={styles.inputContainer}>
            <Input
              className={styles.child}
              label={"Введите отображаемое имя ассистента"}
              labelStyle={styles.labelInput}
              backgroundStyle={styles.labelBackground}
              inputStyle={styles.input}
              value={newWidget ? newWidget?.assistantName : ""}
              name={"assistantName"}
              onChange={handlerInput}
              type={"text"}
              placeholder={"Название"}
            />
          </div>
          <div className={styles.inputContainer}>
            <Input
              className={styles.child}
              label={"Доверенные домены"}
              labelStyle={styles.labelInput}
              backgroundStyle={styles.labelBackground}
              inputStyle={styles.input}
              value={newWidget ? newWidget.allowedDomains : ""}
              name={"allowedDomains"}
              onChange={handlerInput}
              type={"text"}
              placeholder={"Название"}
            />
          </div>
          <ColorPicker
            colorText={colorText}
            setColorText={setColorText}
            colorBg={colorBg}
            setColorBg={setColorBg}
            colorMain={colorMain}
            setColorMain={setColorMain}
          />
        </div>
        <WidgetPreview
          colorBg={newWidget?.backgroundColor}
          colorMain={newWidget?.color}
          colorText={newWidget?.textColor}
          nameAssistant={newWidget?.assistantName}
          titleWidget={newWidget?.header}
        />
      </div>
    </div>
  );
};
